import React, { Fragment } from "react";
import { observer } from "mobx-react-lite";
import styled from "styled-components";
import Modal from 'react-modal';
import { useTranslation } from "react-i18next";
import { CustomModalStyles, ModalDeleteCloseButtonBar, ModalTitle } from "../modal/ModalComponents";
import { AiFillDelete } from "react-icons/ai";
import { charEditorStore } from "../../stores/CharacterEditorStore";
import { gameStore } from "../../stores/GameStore";
const DangerButton = styled.button.withConfig({
  displayName: "CharacterDeleteButton__DangerButton",
  componentId: "sc-wsm12x-0"
})(["color:", ";display:flex;flex-direction:row;flex-shrink:0;"], props => props.disabled ? '#AAAAAA' : '#DD0000');
const DeleteIcon = styled(AiFillDelete).withConfig({
  displayName: "CharacterDeleteButton__DeleteIcon",
  componentId: "sc-wsm12x-1"
})(["margin-right:2px;"]);
export const CharacterDeleteButton = observer(({
  onConfirm,
  disabled
}) => {
  const {
    selectedCharacterConfiguration
  } = charEditorStore;
  const {
    t
  } = useTranslation();
  const [modalIsOpen, setIsOpen] = React.useState(false);

  function openModal() {
    setIsOpen(true);
  }

  function closeModal(e) {
    e === null || e === void 0 ? void 0 : e.stopPropagation();
    setIsOpen(false);
  }

  function confirm() {
    closeModal();
    onConfirm();
  }

  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(DangerButton, {
    disabled: disabled,
    onClick: openModal
  }, /*#__PURE__*/React.createElement(DeleteIcon, null), " ", t("editor.delete_character")), /*#__PURE__*/React.createElement(Modal, {
    isOpen: modalIsOpen,
    onRequestClose: closeModal,
    style: CustomModalStyles,
    shouldCloseOnOverlayClick: true,
    shouldCloseOnEsc: true
  }, /*#__PURE__*/React.createElement(ModalTitle, null, t("editor.character_configuration_delete_modal_title")), t("editor.character_configuration_delete_modal_message", {
    name: selectedCharacterConfiguration === null || selectedCharacterConfiguration === void 0 ? void 0 : selectedCharacterConfiguration.localizedName.get(gameStore.languageKey)
  }), /*#__PURE__*/React.createElement(ModalDeleteCloseButtonBar, {
    confirm: confirm,
    closeModal: closeModal
  })));
});